// extracted by mini-css-extract-plugin
module.exports = {"SectionB":"SectionB_SectionB__eBV8x","ef-box":"SectionB_ef-box__tdjqF"};